
import { Form, Col } from "react-bootstrap";

const FluxDetailsCheckboxes = (props) => {

    return (
        <>
            <Col md={1} style={{ width: "200px", alignContent: "center" }}>
                <Form.Check
                    type="checkbox"
                    name={props.nameField}
                    checked={props.valueField}
                    onChange={(e) => props.handleChange(e)}
                    label={props.labelField}
                    disabled={props.disbaleCheckbox}
                    value={props.valueField}
                ></Form.Check>
            </Col>
        </>
    )

}

export default FluxDetailsCheckboxes;